import { Breadcrumbs, IconButton, Link, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { GridOverlay } from '@material-ui/data-grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../../../App/AppContext';
import { SecondaryButton } from '../../../../Core/FormInput';
import DataGridComp from '../../../../Core/Grid';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import AddEditCashAccountCategories from './AddEdit';
import { getCashAccountCategories } from '../../../../Core/Service/CashAccount-service';

const CashAccountCategories = (props) => {
    const [state, setState] = useState({
        rows: [],
        show: false,

        focusedRow: null,
    });

    const { showToast } = useContext(AppContext);

    const Arrow = (params) => {
        return (
            <>
                <Tooltip title="Update Cash Account Category" aria-label="add">
                    <IconButton size="small" onClick={() => handleAdd(true, params)}>
                        <EditOutlinedIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        );
    };

    const column_new = [
        {
            field: '',
            headerName: 'Action',
            sortable: false,
            width: 120,
            renderCell: (params) => <Arrow value={params} />
        },
        {
            field: 'id',
            headerName: 'ID',
            width: 200,
            hide: true
        },
        {
            field: 'cashAccountCategoryDescription',
            headerName: 'Description',
            flex: 1
        }
    ];

    useEffect(async () => {
        pullCashAccountCategoriesAndUpdateState()
    }, []);

    const pullCashAccountCategoriesAndUpdateState = async () => {
        const res = await getCashAccountCategories()
        if (res.success) {

            const rows = res.data.map((e) => {
                return {
                  id: e.cashAccountCategoryID,
                  cashAccountCategoryDescription: e.cashAccountCategoryDescription
                }
              });

            setState((st) => {
                return {
                    ...st,
                    rows: rows
                };
            });
        }
    };

    const handleAdd = (va, data) => {
        setState((st) => {
            return {
                ...st,
                show: va,
                focusedRow: data?.value?.row ? data.value.row : null 
            };
        });
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No Cash Account Categories Available</div>
            </GridOverlay>
        );
    }

    const closeUpdateUser = (refreshGrid) => {
        setState((st) => ({ ...st, show: false, focusedRow: null }));
        refreshGrid && pullCashAccountCategoriesAndUpdateState();
    };

    return (
        <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', right: 0 }}>
                <SecondaryButton variant="contained" color="secondary" onClick={() => handleAdd(true, null)} className="btnadd">
                    Add Cash Account Category
                </SecondaryButton>
            </div>
            {state.show ?
                <DialogComp title={`${state.focusedRow ? "Update" : "Add"} Cash Account Categories`} onClose={() => handleAdd(false, null)} maxWidth="sm">
                    <AddEditCashAccountCategories onClose={closeUpdateUser} focusedRow={state.focusedRow} />
                </DialogComp>
                : null}
            <Breadcrumbs separator=">>" aria-label="breadcrumb">
                <Link color="inherit" to={'/'}>
                    Home
                </Link>
                <Typography color="secondary" style={{ fontSize: '0.85rem' }}>
                    Cash Categories
                </Typography>
            </Breadcrumbs>

            <DataGridComp rows={state.rows} columns={column_new} enableSearch={true} offset={244} CustomNoRowsOverlay={CustomNoRowsOverlay} />
        </div>
    );
};
export default CashAccountCategories;
